import {useFormik} from 'formik'
import {
  editDemandeDemontage,
  getAllPieceTypePiecesOptions,
  getOneDemandeDemontage,
  getSearchPieceTypePiece,
} from '../../../../components/requests'
import {ModeleDemandeDemontage} from '../../../../components/Models'
import React, {useEffect, useRef, useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {SelectInput} from '../../../../components/inputs/SelectInput'
import {prioriteDemandeDemontage} from '../../../../components/Data'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import {KTIcon} from '../../../../_metronic/helpers'
import {toast} from 'react-toastify'
import {SearchPiece} from '../../../../components/SearchPiece'

const DemandDemontageEditForm = (props) => {
  const {showModalProp, demandeDemontageId, numeroVehicule, setDataDemande, demandeId} = props
  const {currentUser} = useAuth()

  const [valueTypePieces, setValueTypePieces] = useState<any>([])
  const [loadingModal, setLoadingModal] = useState(true)
  const [loading, setLoading] = useState(false)
  const [match, setMatch] = useState<Array<string> | null>([])
  const [suggestion, setSuggestion] = useState<Array<string>>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [clearInput, setClearInput] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [pieceTypePiece, setPieceTypePiece] = useState<string>('')
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)

  const [data, setData] = useState<ModeleDemandeDemontage>({
    typePieces: '',
    commentaire: '',
    priorite: 'Normale',
  })

  // Load autocomplete suggestions
  const getTypePiecesData = async () => {
    try {
      const res = await getAllPieceTypePiecesOptions()
      if (res?.status === 200 && res.data) {
        setSuggestion(res.data.map((item) => item.label))
      }
    } catch (err) {
      console.error('Erreur chargement type pièces', err)
    }
  }

  // Get demandeDemontage
  const getDemandeData = async () => {
    try {
      const res = await getOneDemandeDemontage(demandeDemontageId)
      if (res?.status === 200 && res?.data) {
        const demande = res.data

        const selectedPieces = demande?.typePieces || []
        setValueTypePieces(selectedPieces)

        if (demande?.typePieceHn) {
          const typePieceHorsNom = {
            id: null,
            nom: demande?.typePieceHn,
            code: '999999',
            isHorNom: true,
          }
          setValueTypePieces((prevTypePiece) => [...prevTypePiece, typePieceHorsNom])
        }

        const ids = selectedPieces.map((p) => p.id).join(',')

        setData({
          typePieces: ids,
          commentaire:
            demande?.demandeDemontage?.commentaireModification ??
            demande?.demandeDemontage?.commentaire ??
            '',
          priorite: demande?.demandeDemontage?.priorite || 'Normale',
          typePieceHn: demande?.typePieceHn,
        })
      }
    } catch (err) {
      console.error('Erreur chargement demande démontage', err)
    }
  }

  useEffect(() => {
    const loadData = async () => {
      setLoadingModal(true)
      await Promise.all([getTypePiecesData(), getDemandeData()])
      setLoadingModal(false)
    }

    loadData()
  }, [demandeDemontageId])

  const formik = useFormik<ModeleDemandeDemontage>({
    initialValues: data,
    enableReinitialize: true,
    onSubmit: async (values, formikHelpers) => {
      setLoading(true)

      const typePieces = valueTypePieces
        .map((typePiece) => typePiece.id)
        .filter((value, index, self) => self.indexOf(value) === index)
        .join(',')

      const payload = {
        ...values,
        typePieces,
      }
      try {
        const res = await editDemandeDemontage(demandeDemontageId, payload)
        if (res?.status === 200) {
          setDataDemande((prevData) =>
            prevData.map((demande) =>
              demande.id === res?.data?.id
                ? {...demande, demandeTypePiece: res?.data?.demandeTypePiece}
                : demande
            )
          )

          setValueTypePieces([])
          formikHelpers.resetForm()
          showModalProp(false)
          toast.success(
            `Votre demande de démontage du véhicule n° ${numeroVehicule} a été modifiée avec succès.`
          )
        }
      } catch (err) {
        console.error('Erreur lors de la modification', err)
      } finally {
        setLoading(false)
      }
    },
    validateOnBlur: true,
    validateOnChange: false,
  })

  const searchPieceTypePiece = (inputValue) => {
    setSearchValue(inputValue)
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (inputValue !== '') {
      const match = String(
        suggestion.find((name) => name.toLowerCase().startsWith(inputValue.toLowerCase()))
      ).toLowerCase()
      if (match !== 'undefined') {
        setMatch([inputValue, match.slice(inputValue.length)])
      } else {
        setMatch([])
      }
    } else {
      setMatch([])
    }

    timeoutRef.current = setTimeout(() => {
      if (inputValue !== '') {
        setPieceSpinner(true)
        getSearchPieceTypePiece(inputValue)
          .then((res) => {
            if (res?.status === 200 && res.data) {
              setResultShowPiece(true)
              setPieceTypePiece(res.data)
            }
          })
          .catch(() => {})
          .finally(() => setPieceSpinner(false))
      }
    }, 800)
  }

  const autocompleteOnKeyDown = (e) => {
    if ((e.code === 'Tab' || e.code === 'Enter' || e.code === 'ArrowRight') && match?.length) {
      e.preventDefault()
      e.target.value = match.join('')
      searchPieceTypePiece(e.target.value)
      setMatch([])
    }
  }

  const handleRemovetypePiece = (idToRemove: number) => {
    const updated = valueTypePieces.filter((p) => p.id !== idToRemove)
    setValueTypePieces(updated)
    if (idToRemove === null) formik.setFieldValue('typePieceHn', '')
    formik.setFieldValue('typePieces', updated.map((p) => p.id).join(','))
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        {loadingModal ? (
          <div className='d-flex flex-column flex-center h-100 p-6'>
            <KTIcon iconName='loading' className='fs-3x text-primary mb-2' />
          </div>
        ) : (
          <div>
            <div className='modal-body pt-3'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='col-form-label required fw-bold fs-6'>Pièces</label>
                  <SearchPiece
                    inputClassName='form-control form-control-lg mb-3 mb-lg-0'
                    placeholder='Recherche type pièce'
                    onChange={(e) => searchPieceTypePiece(e.target.value)}
                    onKeyDown={autocompleteOnKeyDown}
                    resultatPiece={pieceTypePiece}
                    value={searchValue}
                    match={match}
                    setMatch={setMatch}
                    setSearchValue={setSearchValue}
                    pieceSpinner={pieceSpinner}
                    resultShowPiece={resultShowPiece}
                    clearInput={clearInput}
                    selectedSearchValue=''
                    showPieceHn={false}
                    onSelect={(selectedPiece) => {
                      if (demandeId && valueTypePieces.length >= 1) { // pour le moment limiter la séléction en une seule pièce
                        setClearInput(true)
                        setSearchValue('')
                        setMatch([]) // Nettoyage du champ d'autocompletion après la selection
                        toast.error('Vous ne pouvez sélectionner qu’une seule pièce', {
                          autoClose: 4000,
                        })
                        return
                      }
                      if (!valueTypePieces.some((p) => p.id === selectedPiece.id)) {
                        const updated = [...valueTypePieces, selectedPiece]
                        setValueTypePieces(updated)
                        formik.setFieldValue('typePieces', updated.map((p) => p.id).join(','))
                      } else {
                        toast.error('Pièce déjà ajoutée dans la liste', {autoClose: 4000})
                      }
                      setClearInput(true)
                      setSearchValue('')
                      setMatch([])
                    }}
                  />
                  {valueTypePieces.length > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                        minHeight: '48px',
                        maxHeight: '120px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        padding: '6px 8px',
                        backgroundColor: '#f9f9f9',
                        cursor: 'text',
                        marginTop: '12px',
                      }}
                    >
                      {valueTypePieces.map((piece) => (
                        <div
                          key={piece.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#e7f3ff',
                            color: '#0d6efd',
                            borderRadius: '16px',
                            padding: '4px 10px',
                            margin: '4px',
                            fontSize: '14px',
                          }}
                        >
                          {/*{piece.nom}*/}
                          {piece?.isHorNom && '[99999]'} {piece.nom}
                          <button
                            type='button'
                            onClick={() => handleRemovetypePiece(piece.id)}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#0d6efd',
                              fontWeight: 'bold',
                              marginLeft: '8px',
                              cursor: 'pointer',
                              fontSize: '16px',
                              lineHeight: '1',
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                      <input
                        type='text'
                        value=''
                        disabled
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          minWidth: '120px',
                          fontSize: '14px',
                          margin: '4px',
                          backgroundColor: 'transparent',
                          color: '#999',
                          cursor: 'not-allowed',
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className='row mt-4'>
                <div className='col-sm-12'>
                  <label className='col-form-label required fw-bold fs-6'>Priorité</label>
                  <SelectInput
                    fieldName='priorite'
                    inputClassName='form-select form-select-lg fw-bold'
                    options={prioriteDemandeDemontage}
                    formik={formik}
                  />
                </div>
              </div>
              <div className='row mt-4'>
                <div className='col-sm-12'>
                  <label className='col-form-label fw-bold fs-6'>Commentaire</label>
                  <TextInput
                    fieldName='commentaire'
                    inputType='text'
                    inputClassName='form-control form-control-lg mb-3 mb-lg-0'
                    formik={formik}
                  />
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <div className='d-flex justify-content-end w-100'>
                <Button variant='secondary me-5' onClick={() => showModalProp(false)}>
                  Annuler
                </Button>
                <Button
                  variant='info'
                  type='submit'
                  disabled={valueTypePieces.length === 0 || loading}
                >
                  {!loading ? (
                    'Enregistrer'
                  ) : (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Enregistrement...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </Button>
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  )
}

export {DemandDemontageEditForm}
